import { render, staticRenderFns } from "./GoodsOrder.vue?vue&type=template&id=4215109d&scoped=true&"
import script from "./GoodsOrder.vue?vue&type=script&lang=js&"
export * from "./GoodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./GoodsOrder.vue?vue&type=style&index=0&id=4215109d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215109d",
  null
  
)

export default component.exports